import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const InternalLink = styled(Link)`
  color: ${props => props.theme.text.linkExternal};
  &:hover {
    color: ${props => props.theme.text.linkExternalHover};
  }
`;

export const ExternalLink = styled.a.attrs({
  rel: 'noopener nofollow',
  target: '_blank',
})`
  color: ${props => props.theme.text.linkExternal};
  &:hover {
    color: ${props => props.theme.text.linkExternalHover};
  }
`;
